module.exports = __webpack_public_path__ + "img/feature1.53da169.png";